import React from 'react';
import AvatarEditor from 'react-avatar-editor';
import '../css/TestimonialForm.css';
import '../css/Form.css';
import '../css/UserStyle.css';
import { fetchUserReviews } from '../../../config/fetchUserFull';
import InputReview from '../components/InputReview';
import Loading from '../components/Loading';
import { Save } from 'react-feather';
import withNavigation from '../components/WithNavigation';

class InsertReviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      submitLoading: false,
      saveDisabled: false,
      image: null,
      scale: 1,
      allowZoomOut: false,
      rotate: 0,
      position: { x: 0, y: 0 },
      x: null,
      y: null,
      preview: null,
      width: 250,
      height: 250,
      ReviewData: {
        id: '',
        name: null,
        profession: null,
        workplace:null,
        review: null,
        original_image: null,
        scale: null,
        position_x: null,
        position_y: null,
        rotate: null,
        method: '',
        image: null,
        scale: 1,
        allowZoomOut: false,
        rotate: 0,
        position: { x: 0, y: 0 },
        preview: null,
        width: 250,
        height: 250,
        x: null,
        y: null,
      },
      DatabaseImg: {
        images: null,

      },
    };
    this.editorRef = React.createRef();
    this.rotateInputRef = React.createRef();
    this.scaleInputRef = React.createRef();
  }


  async componentDidMount() {
    //const { user } = this.props; // Extract the user prop
    const postId = localStorage.getItem('reviewId');
    // const userType = localStorage.getItem('userType');
    const update_id = localStorage.getItem('reviewId');
    console.log('Post ID from local storage:', postId);
    //console.log('Post ID : ', postId);

    try {
      if (postId) {

        this.setState({ isLoading: true });
        const data = await fetchUserReviews(postId); // Pass only the ID to fetchUserData
        //const combinedObj = { ...data[0], ...data[1] };
        //console.log('data combined :', combinedObj); 

        if (data && data.length > 0) {
          if (data[0].original_image) {
            data[0].original_image = `https://yesedacademy.com/database/${data[0].original_image}`;
          }


          console.log('Length of combinedObj:', data[0].image);


          this.setState({
            ReviewData: {
              ...data[0],
              position: { x: data[0].position_x, y: data[0].position_y },

            },
            DatabaseImg: data[0],// Set StudentData state
            method: 'update',
            scale: data[0].scale,
            rotate: data[0].rotate,
            position: { x: data[0].position_x, y: data[0].position_y }

            // Update method if needed
          }, () => {


            this.setState(prevState => ({
              ReviewData: { ...prevState.ReviewData, method: 'update' }
            }));
            localStorage.removeItem('reviewId');
            const postId = '';
            console.log('Post ID : ', postId);
            console.log('update ID : ', update_id);

            console.log('USER name --', this.state.ReviewData.name);
            console.log('USER LEVEL --', this.state.ReviewData.profession);
            console.log('USER ID --', this.state.ReviewData.id);
            console.log('Identity ID --', this.state.ReviewData.workplace);
            console.log('Data : ', this.state.ReviewData);
            console.log('original img : ', this.state.ReviewData.original_image);
            console.log('scale : ', this.state.scale);

            //console.log('fetched data :', this.state.StudentData);
            //const { ReviewData } = this.state;



          });


        } else {
          console.log('No data found for id:', postId); // Log the user ID
        }
      } else {
        localStorage.removeItem('reviewId');
        this.setState({ method: "insert" });
        console.log('No id provided', this.state.ReviewData);
        //const user_type = "Student";

        this.setState(prevState => ({
          ReviewData: { ...prevState.ReviewData, method: 'insert' }
        }));




      }
    } catch (error) {
      console.error('Error fetching user data s:', error);
    } finally {
      this.setState({ isLoading: false });
    }



  }

  


  handleInput = (e) => {
    const { name, value } = e.target;
    let sanitizedValue = value === null ? '' : value;

    if (name === '') {
      this.checkInputExists();
    }


    this.setState(prevState => ({
      ReviewData: {
        ...prevState.ReviewData,
        [name]: sanitizedValue
      }

    }), () => {

      console.log('Data :', this.state.ReviewData);

      //console.log('Date', this.state.joiningDate);

    });

  };

  checkInputExists = () => {
    this.setState({ saveDisabled: true });
  }

  handleImageChange = (e) => {
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const image = reader.result;
      //console.log('newww image : ', image);
      this.setState(prevState => ({
        ReviewData: {
          ...prevState.ReviewData,
          //image: reader.result || prevState.StudentData.image
          original_image: image
        }
      }), () => {
        //console.log('image changed : ',image)
        // Call updatePreview after setting the image with a slight delay
        setTimeout(() => {
          this.updatePreview();
        }, 100);

      });
    };

    if (file && allowedTypes.includes(file.type)) {
      reader.readAsDataURL(file);
    } else {
      // Notify the user that only JPG, JPEG, and PNG files are allowed
      alert('Please select a valid image file (JPG, JPEG, or PNG).');
      // Reset the file input value to prevent selecting an invalid file
      e.target.value = null;
      // Reset the avatar image to the database image if available, otherwise set it to null


      const updated_image = this.state.DatabaseImg.images;
      const databaseImage = updated_image ? updated_image : null;
      //console.log('new image e: ', updated_image);
      this.setState(prevState => ({
        ReviewData: {
          ...prevState.ReviewData,
          original_image: databaseImage
        }

      }), () => {
        //console.log('Image updatedddd:', this.state.StudentData.image);
        // Call updatePreview to reflect the change
        this.updatePreview();
      });
    }


  };

  handleZoomIn = () => {
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        scale: Math.min(prevState.ReviewData.scale + 0.1, 8)
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after zoom in
    });
  };


  handleZoomOut = () => {
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        scale: Math.max(prevState.ReviewData.scale - 0.1, 1)
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after zoom in
    });
  };

  handleXPosition = (e) => {
    const x = parseFloat(e.target.value);
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        position: {
          ...prevState.ReviewData.position,
          x
        }
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after changing X position
    });
  };

  handleYPosition = (e) => {
    const y = parseFloat(e.target.value);
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        position: {
          ...prevState.ReviewData.position,
          y
        }
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after changing Y position
    });
  };

  setEditorRef = editor => {
    if (editor) {
      this.editor = editor;
      this.updatePreview();
    }
  }

  handlePositionChange = (position) => {
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        position,
        position_x: position.x,
        position_y: position.y
      }
    }));
  }

  rotateLeft = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        rotate: prevState.ReviewData.rotate - 90
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after rotating left
    });
  }

  rotateRight = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        rotate: prevState.ReviewData.rotate + 90
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after rotating right
    });
  }

  handleScale = (e) => {
    const scale = parseFloat(e.target.value);
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        scale
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after changing scale
    });
  }

  handleScaleInputChange = (e) => {
    let newScale = parseFloat(e.target.value);
    // Ensure the new scale value is within the allowed range
    if (newScale < (this.state.allowZoomOut ? 0.1 : 1)) newScale = this.state.allowZoomOut ? 0.1 : 1;
    if (newScale > 8) newScale = 8;
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        scale: newScale
      }
    }), () => {
      this.handleScale({ target: { value: newScale } });
    });
  }

  handleRotateChange = (e) => {
    const rotate = parseFloat(e.target.value);
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        rotate
      }
    }), () => {
      this.updatePreview(); // Call updatePreview after changing rotation
    });
  }

  handleRotateNumberChange = (e) => {
    let newRotate = parseInt(e.target.value, 10);
    if (newRotate < -180) newRotate = -180;
    if (newRotate > 180) newRotate = 180;
    this.setState((prevState) => ({
      ReviewData: {
        ...prevState.ReviewData,
        rotate: newRotate
      }
    }));
  }


  updatePreview = () => {

    const img = new Image();
    img.src = this.editor.getImageScaledToCanvas().toDataURL();

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(img, 0, 0);

      const jpgImage = canvas.toDataURL('image/jpeg', 0.8);
      //console.log("image :" ,  );

      this.setState((prevState) => ({
        ReviewData: {
          ...prevState.ReviewData,
          preview: {
            img: jpgImage,
            scale: prevState.ReviewData.scale,
            width: 250,
            height: 250,
          },
        }
      }), () => {



        //this.convertBase64ToBlob();
        console.log('Image pre : ', this.state.ReviewData.preview.img);
        console.log('Image original : ', this.state.ReviewData.original_image);
        //this.handleImageConvert();
      });
    };
  };


  handleSave = async (event) => {
    if (this.state.submitLoading) {
      return;
    }

    event.preventDefault();
    const userConfirmed = window.confirm(`Are you sure you want to ${this.state.ReviewData.method} this review?`);

    if (userConfirmed) {
      const requiredInputs = document.querySelectorAll('#name, #profession, #workplace, #review, #original_image');
      let allInputsValid = true;

      for (let i = 0; i < requiredInputs.length; i++) {
        if (requiredInputs[i].value.trim() === '') {
          allInputsValid = false;
          //this.setState({ saveDisabled: true });
          alert('Please fill out all required fields.');
          break; // Exit the loop on finding an empty input
        }
      }
      
      if (allInputsValid) {
        this.setState({ submitLoading: true });

        try {
          const response = await fetch('https://yesedacademy.com/database/reviewInsert.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.ReviewData)
          });

          const result = await response.json();
          console.log("Response : ", result);

          if (result.status === 'success') {
            this.setState({ submitLoading: false });
            alert(result.message);
            this.props.navigate('/view-reviews');
            //window.location.href = '/view-reviews';
            // handle success (e.g., redirect or update UI)


          } else {
            this.setState({ submitLoading: false });
            alert(result.message);
            // handle error (e.g., display error message)
          }
        } catch (error) {
          console.error('Failed to fetch:', error);
          this.setState({ submitLoading: false });
          alert('Failed to save the review. Please try again later.');
        }
      }
    }
  }


  handleCancel = () => {
    this.setState({ submitLoading: false });
    const userConfirmed = window.confirm(`Are you sure you want to cancel ${this.state.ReviewData.method === "insert" ? 'inserting' : 'updating'} this review?`);
    if (userConfirmed) {
      this.props.navigate('/view-reviews');

    }

  };





  render() {

    const { ReviewData, isLoading, submitLoading, saveDisabled } = this.state;
    console.log("Method : ", this.state.ReviewData.method)


    return (
      <div>
        {isLoading ? (
          <Loading size={100} />
        ) : ReviewData ? (
          <div>


            <div className="container" >
              <div className="row mt-2" >

                <div className="col-md-10"></div>
                <div className="col-md-2 align-items-right">
                  <div className="d-flex justify-content-start align-items-center ">

                    {submitLoading ? <span><Loading size={20} /></span> :
                      <div>
                        <button className='no-hover' onClick={this.handleSave} id="insert2" name="insert2" type='submit' disabled={saveDisabled}>
                          <span><Save className='ico-button' aria-label="Edit" /> Save</span></button>


                        <span className='p-3'>  </span>

                        <button className='no-hover' onClick={this.handleCancel} >
                          <span><Save className='ico-button' aria-label="Edit" /> Cancel</span></button>
                      </div>}


                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2>Insert Review</h2>
            </div>

            <br></br>


            <div className="half left cf">

              <InputReview type="text" id="name" required="required" label="Name *" value={ReviewData.name} onChange={this.handleInput} />
              <InputReview type="text" id="profession" required="required" label="Profession *" value={ReviewData.profession} onChange={this.handleInput} />
              <InputReview type="text" id="workplace" required="required" label="Workplace *" value={ReviewData.workplace} onChange={this.handleInput} />


              <div className="input-container">
                <div className="input-group">
                  <textarea type="text" name="review" id="review" className="input-group__input" required value={ReviewData.review} onChange={this.handleInput} />
                  <label htmlfor="review" className="input-group__label">Review *</label>
                </div>
              </div>

            </div>



            <div className="half right cf">
              {this.state.ReviewData.original_image && (
                <>
                  <div className="input-container">
                    <div className="input-group">
                      <div >
                        <AvatarEditor
                          ref={this.setEditorRef}
                          scale={parseFloat(this.state.ReviewData.scale)}
                          onScaleChange={(scale) => {
                            this.setState((prevState) => ({
                              ReviewData: {
                                ...prevState.ReviewData,
                                scale
                              }
                            }));
                            this.updatePreview(); // Update preview when scale changes
                          }}
                          position={this.state.ReviewData.position}
                          onPositionChange={(position) => {
                            this.setState((prevState) => ({
                              ReviewData: {
                                ...prevState.ReviewData,
                                position
                              }
                            }));
                            this.updatePreview(); // Update preview when position changes
                          }}
                          rotate={parseFloat(this.state.ReviewData.rotate)}
                          onRotateChange={(rotate) => {
                            this.setState((prevState) => ({
                              ReviewData: {
                                ...prevState.ReviewData,
                                rotate
                              }
                            }));
                            this.updatePreview(); // Update preview when rotate changes
                          }}
                          image={this.state.ReviewData.original_image}
                          width={250}
                          height={250}
                          border={0}
                          color={[255, 255, 255, 0.6]}
                          className="avatar-editor"
                          crossOrigin="anonymous"
                          borderRadius={250 / 2}
                          onImageChange={this.state.updatePreview}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="zoom-controls ">
                    Zoom
                    <br></br>
                    <input className='range-input'
                      name="scale" type="range" onChange={this.handleScale}
                      min={this.state.allowZoomOut ? "0.1" : "1"}
                      max="8"
                      step="0.01"
                      //defaultValue={this.state.StudentData.scale !== null ? this.state.StudentData.scale : "1"}
                      value={this.state.ReviewData.scale}
                      ref={this.scaleInputRef}

                    />
                    <input
                      className="number-input"
                      type="number"
                      value={this.state.ReviewData.scale}
                      style={{ width: '70px' }}
                      onChange={this.handleScaleInputChange}
                      step="0.01"
                      min={this.state.allowZoomOut ? "0.1" : "1"}
                      max="8"
                    />
                  </div>
                  <div className="zoom-controls ">

                    Rotate
                    <br></br>
                    <input
                      className='range-input'
                      type="range"
                      id="rotate"
                      name="rotate"
                      min="-180"
                      max="180"
                      step="1"
                      value={this.state.ReviewData.rotate}
                      //defaultValue={this.state.StudentData.rotate !== null ? this.state.StudentData.rotate : "0"}
                      // defaultValue="0"
                      onChange={this.handleRotateChange}
                      ref={this.rotateInputRef}
                    />
                    <input
                      className="number-input"
                      type="number"
                      value={this.state.ReviewData.rotate}
                      style={{ width: '70px' }}
                      onChange={this.handleRotateNumberChange}
                      step="1"
                      min="-180"
                      max="180"

                    />

                  </div>
                  {this.state.preview && (

                    <input type="text" name="photo" id="photo" hidden value={this.state.preview.img} />

                  )}

                </>
              )}
              <div className="input-container">
                <div className="input-group">
                  <input
                    type="file"
                    name="image"
                    id="image"
                    className="input-group__input_image"
                    onChange={this.handleImageChange}
                    required
                  />
                  <label htmlFor="image" className="input-group__label">
                    Photo *
                  </label>
                </div>
              </div>
            </div>

            <input type="text" name="actionToPerform" id="actionToPerform" hidden value={this.state.ReviewData.method} />
            <input type="text" name="original_image" id="original_image" hidden value={this.state.ReviewData.original_image} />
            <input type="text" name="scale" id="scale" hidden value={this.state.scale} />
            <input type="text" name="rotate" id="rotate" hidden value={this.state.rotate} />
            <input type="text" name="position_x" id="position_x" hidden value={this.state.x} />
            <input type="text" name="position_y" id="position_y" hidden value={this.state.y} />
            <input type="text" name="id" id="id" hidden value={this.state.ReviewData.id} />





          </div>

        ) : (
          <p>No data available</p>
        )}

      </div>


    );
  }
}

export default withNavigation(InsertReviews);
